import { render, staticRenderFns } from "./SelectedProgram.vue?vue&type=template&id=20b6803a"
import script from "./SelectedProgram.vue?vue&type=script&lang=js"
export * from "./SelectedProgram.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports